<template>
  <div style=" background-color: #F5F6FA;display: flex;flex-direction: column; height: 100%; ">
    <hear :num=1></hear>
    <BDhear :num=1></BDhear>
 <div style="flex:1;" v-if="cion">   <SelectALot></SelectALot> </div>
 <div style="flex:1;" v-else><SelectALots></SelectALots> </div>
      
  </div>
</template>

<script>
import hear from '.././../components/hear.vue'
import BDhear from './BDhear.vue'
import SelectALot from './SelectALot.vue'
import SelectALots from './SelectALots.vue'
export default {
  components: {
    hear,
    BDhear,
    SelectALot,
      SelectALots,
  },
  name: 'BidSecunity',
  data() {
    return {
cion:false
    }
  },
  created(){
if(sessionStorage.getItem("bhlein")=="投标保函"){
this.cion=true
}
  },
}
</script>

<style scoped>
.box{
  width: 100px;
  height: 100px;
  background: palegoldenrod;
}
</style>



// WEBPACK FOOTER //
// src/view/BidSecurity/BidSecurity.vue